import React from "react";
import FormikRadioGroup from "../fields/FormikRadioGroup";
import FormikSelectField from "../fields/FormikSelectField";
import {
  aiExperienceOptions,
  expectationOptions,
  obstacleOptions,
} from "../data/fieldOptions";

const DiagnosisStep = () => (
  <div className="step">
    <h3 className="main_question">
      <strong>3/4</strong>Diagnóstico inicial de tu proyecto
    </h3>
    <FormikSelectField
      name="obstacle"
      label="¿Cuál es tu mayor obstáculo actual para estructurar o postular tu proyecto?"
      placeholder="Selecciona tu principal obstáculo"
      options={obstacleOptions}
      required
    />
    <FormikRadioGroup
      name="experience"
      label="¿Has utilizado herramientas de Inteligencia Artificial para tu emprendimiento antes?"
      options={aiExperienceOptions}
      required
    />
    <FormikSelectField
      name="expectation"
      label="¿Qué esperas lograr principalmente al probar Upbirk?"
      placeholder="Selecciona tu principal expectativa"
      options={expectationOptions}
      required
    />
  </div>
);

export default DiagnosisStep;
